import React from 'react'

import Dropdown from "./ReactDropdown";

export default class DropdownWorkingAtYearAndLevel extends Dropdown
{		
	
	// Entry properties
	//
	// mode : 'list' - Just act like a dropdown with each role itemised
	//        'filter' - act as a drop down filter list, including an 'ALL' option
	
	static get defaultProps() 
	{
		let v =
			{
				mode: 'list',
				label: 'Select a Value',
				defaultValue: 0,
				maxValue: 90
			}

		return v;
	}
	
	constructor(props) 
	{
		super(props);
		
		this.keyCount = 0 ;

		if ( this.props.defaultValue == null || this.props.defaultValue > this.props.maxValue )
		{
			var def = 0 ;
		}
		else
		{
			def = this.props.defaultValue ;
		}


    	// Create a state item here
		this.state = { dirty: false, currentValue: def, items: null };

		this.isDirty = this.isDirty.bind(this) ;
		this.setDirty = this.setDirty.bind(this) ;

	}

	UNSAFE_componentWillMount()
	{		
		// Fetch the list of types to populste the dropdown
		this.getdata () ;
	}

	getGCSETypes()
	{
		const progresstypes = [
			{
				id: 50,
				desc: 'GCSE Grade 1'
			},
			{
				id: 51,
				desc: 'GCSE Grade 2'
			},
			{
				id: 52,
				desc: 'GCSE Grade 3'
			},
			{
				id: 53,
				desc: 'GCSE Grade 4'
			},
			{
				id: 54,
				desc: 'GCSE Grade 5'
			},
			{
				id: 55,
				desc: 'GCSE Grade 6'
			},
			{
				id: 56,
				desc: 'GCSE Grade 7'
			},
			{
				id: 57,
				desc: 'GCSE Grade 8'
			},
			{
				id: 58,
				desc: 'GCSE Grade 9'
			},
		];

		return progresstypes ;
	}

	getOtherTypes()
	{
		const progresstypes = [
			{
				id: 70,
				desc: 'Other'
			},
		];

		return progresstypes ;
	}


	getNonGCSETypes()
	{
		const progresstypes = [
			{
				id: 1,
				desc: 'Emerging Y1'
			},
			{
				id: 2,
				desc: 'Developing Y1'
			},
			{
				id: 3,
				desc: 'Secure Y1'
			},
			{
				id: 4,
				desc: 'Greater Depth Y1'
			},
			{
				id: 5,
				desc: 'Emerging Y2'
			},
			{
				id: 6,
				desc: 'Developing Y2'
			},
			{
				id: 7,
				desc: 'Secure Y2'
			},
			{
				id: 8,
				desc: 'Greater Depth Y2'
			},
			{
				id: 9,
				desc: 'Emerging Y3'
			},
			{
				id: 10,
				desc: 'Developing Y3'
			},
			{
				id: 11,
				desc: 'Secure Y3'
			},
			{
				id: 12,
				desc: 'Greater Depth Y3'
			},
			{
				id: 13,
				desc: 'Emerging Y4'
			},
			{
				id: 14,
				desc: 'Developing Y4'
			},
			{
				id: 15,
				desc: 'Secure Y4'
			},
			{
				id: 16,
				desc: 'Greater Depth Y4'
			},
			{
				id: 17,
				desc: 'Emerging Y5'
			},
			{
				id: 18,
				desc: 'Developing Y5'
			},
			{
				id: 19,
				desc: 'Secure Y5'
			},
			{
				id: 20,
				desc: 'Greater Depth Y5'
			},
			{
				id: 21,
				desc: 'Emerging Y6'
			},
			{
				id: 22,
				desc: 'Developing Y6'
			},
			{
				id: 23,
				desc: 'Secure Y6'
			},
			{
				id: 24,
				desc: 'Greater Depth Y6'
			},
			{
				id: 25,
				desc: 'Emerging Y7'
			},
			{
				id: 26,
				desc: 'Developing Y7'
			},
			{
				id: 27,
				desc: 'Secure Y7'
			},
			{
				id: 28,
				desc: 'Greater Depth Y7'
			},
			{
				id: 29,
				desc: 'Emerging Y8'
			},
			{
				id: 30,
				desc: 'Developing Y8'
			},
			{
				id: 31,
				desc: 'Secure Y8'
			},
			{
				id: 32,
				desc: 'Greater Depth Y8'
			},
			{
				id: 33,
				desc: 'Emerging Y9'
			},
			{
				id: 34,
				desc: 'Developing Y9'
			},
			{
				id: 35,
				desc: 'Secure Y9'
			},
			{
				id: 36,
				desc: 'Greater Depth Y9'
			}
		];

		return progresstypes ;
	}

	isYear9()
	{
		if ( this.props.year_id == '9' )
		{
			return true ;
		}
		else
		{
			return false ;
		}
	}

	isKeyStage4()
	{
		if ( this.props.year_id == '10' || this.props.year_id == '11' )
		{
			return true ;
		}
		else
		{
			return false ;
		}
	}

	getdata( )
	{
		let progresstypes = [] ;

		if ( this.isYear9() )
		{
			progresstypes = this.getNonGCSETypes().concat(this.getGCSETypes()) ;
		}
		else if ( this.isKeyStage4())
		{
			progresstypes = this.getGCSETypes().concat(this.getOtherTypes()) ;
		}
		else
		{
			progresstypes = this.getNonGCSETypes();
		}

		this.setState ( { items : progresstypes } ) ;
	}

	sendChangeNotification()
	{
		if ( this.state.dirty == false )
		{
			if ( this.props.onDirty != null )
			{
				// Send a dirty notification if required, and only the first time we change
				this.props.onDirty() ;
			}
		}
	}

	handleChange(e) 
	{
		var targetName = e.target.name ;
		var val = e.target.value ;
		var index = e.target.selectedIndex;

		// Need to calculate the offset to read the actual Type Id from the correct place in the table
		// If it is a 'filter' then there is an extra entry in the listbox called 'ALL' which we need to account for
		
		var offset = -1 ;

		if ( index > 0 )
		{
			var itemid = this.state.items[index+offset].id;			
			var itemtext = this.state.items[index+offset].desc ;

			this.sendChangeNotification() ;

			this.setState ( {dirty: true, currentValue: itemid} ) ;
		}
		else
		{
			var itemid = 0 ;		
			var itemtext = "All" ;

			this.sendChangeNotification() ;

			this.setState ( {dirty: true, currentValue: itemid} ) ;
		}
		
		// Tell the owning function about the change	
		
		if ( this.props.callback != null )
		{
			this.props.callback ( itemtext ) ;		
		}
		
	}
	  
	/**
	* Returns true if the input value complies with the validation rules supplied
	* 
	* @param {string} param - The value of the string to be tested.
	* @return {bool} true if the test passes.
	*/
	isValueValid( param )
	{
		if ( this.props.validation != null )
		{
			if ( this.props.validation.required == true )
			{
				if ( param == null || param == 0)
				{
					return false ;
				}
			}
			else
			{
				if ( param == null || param == 0)
				{
					// If not required, and empty, it's OK
					return true ;
				}
			}			
		}

		return true ;
	}

	/**
	* Externally callable function to test if the input field is valid
	* 
	* @return {bool} True if the field is valid.
	*/
	isValid()
	{		
		return this.isValueValid ( this.getValue() ) ;
	}
	
    getValue()
    {
    	return this.state.currentValue ;
    }
    
	/**
	* Externally callable function to test if the input field is valid
	* 
	* @return {bool} True if the field is valid.
	*/
	isDirty()
	{		
		return this.state.dirty ;
	}

	setDirty ( value )
	{
		this.setState ({dirty: value}) ;
	}
	
    optionList ()
    {
        var lineList=[];
        
        // This element renders from the list of user types returned by the getdata() ajax function above
    	var itemArray = this.state.items ;

    	if ( itemArray != null )
        {
        	var i = 0 ;
            var len = itemArray.length;
            var row = null ;
            var typeId = null ;
            var typeText = null ;
            
            // If it's a filter list, add the 'ALL' option
            
    		lineList.push(React.createElement ( 'option', {key: this.keyCount++, name: 0, value: 0} , 'Select a Value'));        	
    		
            for (i=0; i<len; ++i) 
            {
            	if (i in itemArray) 
            	{
            		row = itemArray[i];
            		
            		typeId = row.id ;
            		typeText = row.desc;
            		
            		lineList.push(React.createElement ( 'option', {key: this.keyCount++, name: typeId, value: typeId} , typeText));        			
            	}
            }
        }
        
        return lineList ;
    }
    
    dropdown_select ( id )
    {
    	return React.createElement ( 'select', {key: this.keyCount++, value: this.state.currentValue, tabIndex: this.props.tabIndex, className: 'form-control', id: id , onChange: this.handleChange.bind(this)}, this.optionList() ) ;
    }
    
    render()
    {
		this.keyCount = 0 ;
		if ( this.props.readOnly !== 'readonly' )
		{
			return React.createElement ( 'div', {key: this.keyCount++, className: this.props.containerClassName}, this.optionDropdown('list1')) ;
		}
		else
		{
			return React.createElement ( 'div', {key: this.keyCount++}, this.readOnlyField()) ;
		}
    }
};

